import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import * as CategoriasService from 'services/categoria.service'

import * as FormGroups from './formGroups'

const NuevoActualizarModal = ({ show, handleClose, editarData, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      nombre: editarData.nombre
    }
  }, [editarData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const funcionEjecutar = editarData._id
        ? () => CategoriasService.actualizarxId(editarData._id, data)
        : () => CategoriasService.nuevo(data)

      funcionEjecutar()
        .then(({ data: responseData }) => {
          __zariContext.toast('success', editarData._id ? 'Registro actualizado.' : 'Registro creado.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, editarData, handleClose, reloadTable]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'Editar categoria' : 'Nueva categoria'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <FormGroups.NombreFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.nombre}
                iTouched={touched.nombre}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Guardar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevoActualizarModal)
